import general from './general.json';
import siteSearch from './site-search.json';
import requestQuote from './request-quote.json';
import utilization from './account/utilization.json';
import paymentAccount from './account/payment-account.json';
import paymentAndBilling from './account/payment-and-billing.json';
import { NestedMessagesType } from '../../types/locale';

const locales_en_US: NestedMessagesType = {
  ...general,
  ...requestQuote,
  siteSearch,
  account: {
    utilization,
    paymentAccount,
    paymentAndBilling
  },
};

export default locales_en_US;
